import { render } from "./Received_information.vue?vue&type=template&id=41c7c9c8"
import script from "./Received_information.vue?vue&type=script&lang=js"
export * from "./Received_information.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__